import {Box, Stack, styled, Tab, Tabs, Typography} from "@mui/material";
import React, {useState} from "react";
import {useTheme} from "@mui/material/styles";
import {examples} from "../../../utils/apiEndpoints";
import PythonExplainerDocStyled from "./PythonParser";
import Button from "@mui/material/Button";

function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

// Utility to trigger a .py file download from a string
function downloadPy(filename: string, code: string) {
  const normalized = code.replace(/\r\n?/g, "\n").replace(/\s*$/, "\n");
  const blob = new Blob([normalized], { type: "text/x-python;charset=utf-8" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".py") ? filename : `${filename}.py`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url); // cleanup
}


const ApiDemonstrations = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const handleChange = (e, newIndex) => setTabIndex(newIndex);
  const theme = useTheme()

  const handleDownload = (index) => {
    const code = examples[index].code;
    const filename = `example_${index + 1}.py`;
    downloadPy(filename, code);
  }
  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <Tabs
        value={tabIndex}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          minHeight: 0,
          marginBottom: 1,
          '& .MuiTabs-flexContainer': {
            justifyContent: 'center',
          },
        }}
        TabIndicatorProps={{ style: { display: 'none' } }}
      >
        {examples.map((c, i) => (
          <Tab
            key={i}
            label={c.title}
            sx={{
              fontSize: 'small',
              textTransform: 'none',
              p: '8px 16px',
              m: '0px 4px 8px 4px',
              borderRadius: 2,
              minHeight: 0,
              minWidth: 0,
              bgcolor: theme.palette.grey[200],
              '&.Mui-selected': {
                bgcolor: 'primary.main',
                color: 'primary.contrastText',
                borderRadius: 20,
              },
            }}
          />
        ))}
      </Tabs>

      {/* Panel contents */}
      {examples.map((c, i) => (
        <TabPanel
          key={i}
          value={tabIndex}
          index={i}
        >
          <Stack>
            <PythonExplainerDocStyled code={c.code} />
            <Button
              onClick={() => handleDownload(i)}
              variant={'contained'}
              color={'secondary'}
              sx={{
                width: {xs: '100%', sm: '250px'},
                marginTop: 2,
                alignSelf: 'center',
                fontSize: 'small',
              }}
            >
              DOWNLOAD FULL EXAMPLE
            </Button>
          </Stack>
        </TabPanel>
      ))}
    </Box>
  )
}

export default ApiDemonstrations;